import styled from 'styled-components';
import { rem } from 'polished';

const Container = styled.div`
    margin: ${rem(8)} 0;
`;

export default Container;
